export const PRIVACY_POLICY = "https://www.optum.com/privacy-policy.html";
export const TERMS_OF_USE = "https://www.optum.com/terms-of-use.html";
export const FEEDBACK_LINK = "https://hcmsubmitonly.ideas.aha.io/ideas/new";
